/* This file will have the bread crumb details pertaining to each page of the application */

export const PIVOTS = {
    '/manage': 'Manage Product',
    '/manageProduct': 'Single Product Page',
    '/summary': 'UserSummary'
};
